<template>
  <div class="admin-start-hub__card">
    <div class="admin-start-hub__notif-head">
      <span class="admin-start-hub__card-label">{{ card.label }}</span>
      <span class="admin-start-hub__badge">{{ badge }}</span>
    </div>
    <ul v-if="items.length" class="admin-start-hub__notif-list">
      <li v-for="(item, index) in items" :key="index">
        <a :href="item.href || card.href">
          <span class="admin-start-hub__notif-dot" aria-hidden="true"></span>
          <span>{{ item.label }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'StartHubNotificationsCard',
  props: {
    card: { type: Object, required: true },
    unreadSuffix: { type: String, required: true },
  },
  computed: {
    items() {
      return Array.isArray(this.card.items) ? this.card.items : [];
    },
    badge() {
      const count = Number(this.card.count || 0).toLocaleString('it-IT');
      return `${count} ${this.unreadSuffix}`;
    },
  },
};
</script>
